import Button from '@platform-ui-common/components/Button/index.js';
import Icon from '@platform-ui-common/components/Icon/index.js';
import EmailLink from '@platform-ui-common/components/Link/EmailLink.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import useCustomPageTitle from '@platform-ui-common/hooks/useCustomPageTitle.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { formatCurrency } from '@platform-ui-common/utilities/format.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import useLogout from '@platform-ui/auth/hooks/useLogout.js';
import useClaim from '@platform-ui/claim/hooks/useClaim.js';

export default function PaymentFailed(): JSX.Element {
  const { logout, loading } = useLogout();
  const { fulfillment } = useClaim();
  const { email } = usePartner();

  const approvedAmount = fulfillment ? formatCurrency(fulfillment.approvedAmount, true) : 'N/A';
  const heading = 'Payment transaction failed';
  useCustomPageTitle(heading);

  return (
    <div className="w-full flex flex-col gap-y-4 items-center text-center">
      <div className="w-3/4 flex flex-col pb-8">
        <Typography variant="h1">{heading}</Typography>
      </div>
      <div className="text-center">
        <Icon color={Color.Error} type={'reportGmailErrorRed'} size="XXL" className="pt-px" />
      </div>

      <div className="w-auto md:w-1/2 mx-8 text-center items-center">
        <Typography variant="body">
          We have all hands on deck working on getting you back up and running. This does not affect
          your award amount of {approvedAmount}
        </Typography>
        <div className="w-auto my-10">
          <Typography variant="body">
            Please contact us at <EmailLink>{email}</EmailLink> and we will work with you to resolve
            this issue as quickly as possible.
          </Typography>
        </div>
        <div className="flex flex-col gap-y-4 items-center">
          <Button disabled={loading} onClick={logout}>
            {' '}
            Log Out
          </Button>
          <Button variant="outline" link={ApplicantRoutes.APPLICATION_PORTAL}>
            Back To Application Portal
          </Button>
        </div>
      </div>
    </div>
  );
}
